import { withNormalizedOffer } from "./offers";

export const DEFAULT_DATA = {
  services: [
    {
      id: "netflix",
      nombre: "Netflix",
      categoria: "video",
      color: "#e50914",
      logo: "N",
      planes: [
        { nombre: "1 Pantalla", precio: 4.5 },
        { nombre: "2 Pantallas", precio: 7 },
        { nombre: "4 Pantallas (UHD)", precio: 10 },
      ],
    },
    {
      id: "prime",
      nombre: "Amazon Prime Video",
      categoria: "video",
      color: "#00a8e1",
      logo: "prime",
      imagen: "/img/prime.jpg",
      planes: [
        { nombre: "1 Mes", precio: 3.5 },
        { nombre: "3 Meses", precio: 9 },
      ],
    },
    {
      id: "hbo",
      nombre: "HBO Max",
      categoria: "video",
      color: "#9b5cff",
      logo: "max",
      imagen: "/aarchivos/HBO-Max-Logo.png",
      planes: [
        { nombre: "1 Mes", precio: 4 },
        { nombre: "3 Meses", precio: 10.5 },
      ],
    },
    {
      id: "disney",
      nombre: "Disney+",
      categoria: "video",
      color: "#2f7cff",
      logo: "Disney+",
      imagen: "/img/disney.png",
      planes: [
        { nombre: "1 Mes", precio: 4 },
        { nombre: "3 Meses", precio: 10 },
      ],
    },
    {
      id: "ytpremium",
      nombre: "YouTube Premium",
      categoria: "video",
      color: "#ff3b30",
      logo: "play",
      imagen: "/img/youtube-premium-logo-png-640x640_81dc51f2_transparent.png",
      planes: [
        { nombre: "1 Mes", precio: 3 },
        { nombre: "3 Meses", precio: 8 },
      ],
    },
    {
      id: "spotify",
      nombre: "Spotify",
      categoria: "audio",
      color: "#1ed760",
      logo: "Spotify",
      imagen: "/aarchivos/spotify-logo-free-download-free-vector.jpg",
      planes: [
        { nombre: "1 Mes", precio: 3.5 },
        { nombre: "3 Meses", precio: 9 },
      ],
    },
    {
      id: "ytmusic",
      nombre: "YouTube Music",
      categoria: "audio",
      color: "#ff3657",
      logo: "Music",
      imagen: "/img/Youtube-Music-Logo-PNG-Pic.png",
      planes: [{ nombre: "1 Mes", precio: 3 }],
    },
    {
      id: "iptvsmarters",
      nombre: "IPTV Smarters Pro",
      categoria: "iptv",
      color: "#6c5ce7",
      logo: "IPTV",
      imagen: "/aarchivos/bd617d84f1eadfd37f80932442c199f4.jpg",
      planes: [
        { nombre: "1 Mes", precio: 8 },
        { nombre: "3 Meses", precio: 22 },
      ],
    },
    {
      id: "iboplayer",
      nombre: "IBO Player Pro",
      categoria: "iptv",
      color: "#ff9f43",
      logo: "IBO",
      imagen: "/aarchivos/IBO_PLAYER_PRO_logo.png",
      planes: [
        { nombre: "1 Mes", precio: 8 },
        { nombre: "3 Meses", precio: 22 },
      ],
    },
  ],
  storeProducts: [
    {
      id: "smart-tv-43",
      nombre: "Smart TV 43 pulgadas",
      categoria: "video",
      subcategoria: "tv",
      descripcion: "Pantalla inteligente Full HD con aplicaciones de streaming listas para usar.",
      precio: 289,
      costo: 240,
      moneda: "USD",
      stock: 4,
      vendidos: 0,
      imagen: "",
      badge: "Disponible",
      activo: true,
    },
    {
      id: "speaker-mini",
      nombre: "Bocina Bluetooth Mini",
      categoria: "audio",
      subcategoria: "bocinas",
      descripcion: "Sonido portátil, conexión Bluetooth y batería para todo el día.",
      precio: 32,
      costo: 24,
      moneda: "USD",
      stock: 9,
      vendidos: 0,
      imagen: "",
      badge: "Más vendido",
      activo: true,
    },
    {
      id: "charger-20w",
      nombre: "Cargador rápido 20W",
      categoria: "accesorios",
      subcategoria: "cargadores",
      descripcion: "Carga compacta y segura para teléfonos, tabletas y otros dispositivos.",
      precio: 18,
      costo: 11,
      moneda: "USD",
      stock: 18,
      vendidos: 0,
      imagen: "",
      badge: "Nuevo",
      activo: true,
    },
    {
      id: "digital-setup",
      nombre: "Configuración Smart TV",
      categoria: "digitales",
      subcategoria: "configuraciones",
      descripcion: "Instalación remota de aplicaciones y configuración inicial del equipo.",
      precio: 15,
      costo: 8,
      moneda: "USD",
      stock: 99,
      vendidos: 0,
      imagen: "",
      badge: "Servicio digital",
      activo: true,
    },
  ],
  perfumeProducts: [],
  perfumeConfig: {
    activo: true,
    titulo: "Encuentra una fragancia que hable por ti.",
    descripcion: "Explora perfumes originales, revisa sus detalles y completa tu compra con atención directa.",
  },
  gameRechargeConfig: {
    activo: true,
    titulo: "Recargas de juegos",
    descripcion: "Elige tu juego, selecciona la recarga y envíanos los datos de la cuenta por WhatsApp.",
    instrucciones: "Selecciona un juego, elige un paquete, escribe manualmente el ID y el nombre del jugador, y confirma el pedido por WhatsApp.",
    juegos: [
      { id: "free-fire", slug: "free-fire", nombre: "Free Fire", descripcion: "Diamantes y bonos para tu cuenta.", icono: "spark", color: "#f28a1a", imagen: "/img/freefire-diamond-crate-transparent.png", activo: true, unidad: "diamantes", paquetes: [
        { id: "ff-100", nombre: "100 + 10 diamantes", cantidad: 100, bonus: 10, precio: 0, moneda: "USD", activo: true },
        { id: "ff-310", nombre: "310 + 31 diamantes", cantidad: 310, bonus: 31, precio: 0, moneda: "USD", activo: true },
        { id: "ff-520", nombre: "520 + 52 diamantes", cantidad: 520, bonus: 52, precio: 0, moneda: "USD", activo: true },
        { id: "ff-1060", nombre: "1,060 + 106 diamantes", cantidad: 1060, bonus: 106, precio: 0, moneda: "USD", activo: true },
        { id: "ff-2180", nombre: "2,180 + 218 diamantes", cantidad: 2180, bonus: 218, precio: 0, moneda: "USD", activo: true },
        { id: "ff-5600", nombre: "5,600 + 560 diamantes", cantidad: 5600, bonus: 560, precio: 0, moneda: "USD", activo: true },
      ] },
      { id: "delta-force", slug: "delta-force", nombre: "Delta Force", descripcion: "Créditos y contenido para tu operador.", icono: "target", color: "#42c98d", imagen: "", activo: true, unidad: "créditos", paquetes: [{ id: "delta-personalizada", nombre: "Recarga personalizada", cantidad: 0, bonus: 0, precio: 0, moneda: "USD", activo: true }] },
      { id: "genshin-impact", slug: "genshin-impact", nombre: "Genshin Impact", descripcion: "Cristales y bendiciones para tu aventura.", icono: "gem", color: "#6f9fff", imagen: "", activo: true, unidad: "cristales", paquetes: [{ id: "genshin-personalizada", nombre: "Recarga personalizada", cantidad: 0, bonus: 0, precio: 0, moneda: "USD", activo: true }] },
      { id: "blood-strike", slug: "blood-strike", nombre: "Blood Strike", descripcion: "Oro y paquetes para entrar en combate.", icono: "crosshair", color: "#e84c59", imagen: "", activo: true, unidad: "oro", paquetes: [{ id: "blood-personalizada", nombre: "Recarga personalizada", cantidad: 0, bonus: 0, precio: 0, moneda: "USD", activo: true }] },
      { id: "arena-blackop", slug: "arena-blackop", nombre: "Arena Blackop", descripcion: "Recargas y paquetes para tu cuenta.", icono: "shield", color: "#b7935b", imagen: "", activo: true, unidad: "créditos", paquetes: [{ id: "arena-personalizada", nombre: "Recarga personalizada", cantidad: 0, bonus: 0, precio: 0, moneda: "USD", activo: true }] },
    ],
  },
  suggestionConfig: {
    activo: true,
    email: "",
    titulo: "¿No encuentras lo que necesitas?",
    descripcion: "Cuéntanos qué producto buscas, para cuándo lo necesitas y cómo podemos ayudarte.",
  },
  storeFolders: {
    video: [
      { id: "tv", nombre: "TV" },
      { id: "pantallas", nombre: "Pantallas" },
      { id: "camaras", nombre: "Cámaras" },
      { id: "telefonos", nombre: "Teléfonos" },
    ],
    audio: [
      { id: "bocinas", nombre: "Bocinas" },
      { id: "audifonos", nombre: "Audífonos" },
      { id: "radios", nombre: "Radios" },
      { id: "microfonos", nombre: "Micrófonos" },
    ],
    accesorios: [
      { id: "cargadores", nombre: "Cargadores" },
      { id: "cables", nombre: "Cables" },
      { id: "adaptadores", nombre: "Adaptadores" },
      { id: "gadgets", nombre: "Gadgets" },
    ],
    digitales: [
      { id: "activaciones", nombre: "Activaciones" },
      { id: "instalaciones", nombre: "Instalaciones" },
      { id: "configuraciones", nombre: "Configuraciones" },
      { id: "licencias", nombre: "Licencias" },
    ],
  },
  storeRevision: 2,
  peliculasDestacadas: [
    {
      id: "spider-verse",
      titulo: "Spider-Man: Across the Spider-Verse",
      imagen: "/aarchivos/1986933.jpg",
      sinopsis: "Miles Morales vuelve a cruzar el multiverso y descubre que ser héroe también significa elegir su propio camino.",
    },
    {
      id: "agente-kim",
      titulo: "Agente Kim: Reactivado",
      imagen: "/aarchivos/AAAABX6Xk6FXWoSKp-TNJl2J7CZPSbkYbAT4yPqtv23ZPqlK0jCyZvh5ln9cpAZqDVMo7nAUD0yI7sU1QeWHfwNymDTbRFu2GKkyBBmSIn93ociBt9aeWO0wshsmkFdwoMWLn_f_kpFPDlE93o8vIuTYJBKKLlMFpFu3Q1Ikr2mGiTqYk9phfk2goItTpnw4PhYU.jpg",
      sinopsis: "Un agente retirado vuelve a la acción cuando una nueva amenaza pone a prueba todo lo que creía haber dejado atrás.",
    },
    {
      id: "asi-aprenderas",
      titulo: "Así aprenderás",
      imagen: "/aarchivos/AAAABcRYyKTaCqR51eIjntLwLBPU8gnyIg44KLynxAeiP4hEngzlzA56ubzm-D8dyanVWwebe_tp_JPAcO2n2YIl-5AMRv9pJjItfFuY7MRBHGDibob3eTcV1M73fseoEy0PFVpHVrEAEEyAvh_QqTSdJOckDPjvZ-9Z0wNB.jpg",
      sinopsis: "Un estudiante convierte cada conflicto del aula en una oportunidad inesperada para cambiar su historia.",
    },
  ],
  flujoTVPlanes: [
    { servicio: "Flujo TV", nombre: "1 Mes · 3 dispositivos", precio: 9.33 },
    { servicio: "Flujo TV", nombre: "3 Meses · 3 dispositivos", precio: 26 },
    { servicio: "Flujo TV", nombre: "6 Meses · 3 dispositivos", precio: 46 },
    { servicio: "Flujo TV", nombre: "1 Año + 2 Meses Gratis", precio: 90 },
  ],
  contacto: {
    whatsapp: "8492829921",
    mensaje: "Hola, quiero activar mi cuenta de",
  },
  socialLinks: {
    tiktok: { url: "", activo: true },
    facebook: { url: "", activo: true },
    instagram: { url: "", activo: true },
    whatsapp: { url: "", activo: true },
  },
  metodosPago: [
    { id: "popular", nombre: "Banco Popular", tipo: "Cuenta corriente", cuenta: "817891138", titular: "Rafael Agramonte", instruccion: "Transferencia en pesos dominicanos", activo: true },
    { id: "banreservas", nombre: "Banco Banreservas", tipo: "Cuenta de ahorro", cuenta: "9603478919", titular: "Rafael Agramonte", instruccion: "Transferencia en pesos dominicanos", activo: true },
    { id: "bhd", nombre: "Banco BHD", tipo: "Cuenta de ahorro", cuenta: "29866320010", titular: "Rafael Agramonte", instruccion: "Transferencia en pesos dominicanos", activo: true },
    { id: "caribe", nombre: "Banco Caribe", tipo: "Cuenta bancaria", cuenta: "4011495571", titular: "Rafael Agramonte", instruccion: "Confirma el tipo de cuenta antes de transferir", activo: true },
    { id: "asociacion-popular", nombre: "Asociación Popular", tipo: "Cuenta de ahorro", cuenta: "1026948584", titular: "Rafael Agramonte", instruccion: "Transferencia en pesos dominicanos", activo: true },
    { id: "qik", nombre: "Banco Qik", tipo: "Cuenta de ahorro", cuenta: "1000036974", titular: "Rafael Agramonte", instruccion: "También disponible para pagos desde Mi Punto", activo: true },
    { id: "ademi", nombre: "Banco Ademi", tipo: "Cuenta de ahorro", cuenta: "21055428419751", titular: "Rafael Agramonte", instruccion: "Transferencia en pesos dominicanos", activo: true },
    { id: "xoom", nombre: "Remesa por Xoom", tipo: "Remesa internacional", cuenta: "", titular: "Rafael Agramonte", instruccion: "Solicita los datos vigentes antes de completar la remesa", activo: true },
    { id: "binance", nombre: "Binance Pay", tipo: "Binance Pay ID", cuenta: "", titular: "Rafael Agramonte", instruccion: "Solicita el Pay ID vigente antes de enviar USDT", activo: true },
  ],
  paymentRevision: 2,
  flujoTVDownload: {
    tvUrl: "https://descargarflujotv.app/tv",
    tvCodes: "9381417, 5586125 o 3261241",
    celularUrl: "https://descargarflujotv.app/cel",
  },
  iptvDownload: {
    tvUrl: "https://descargarflujotv.app/tv",
    celularUrl: "https://descargarflujotv.app/cel",
    evoCode: "9381417",
    iboCode: "9381417",
    smartersCode: "654655",
  },
  downloadPages: {
    iptv: {
      name: "IPTV Smarters Pro",
      shortName: "IPTV",
      path: "/instalar/iptv-smarters-pro",
      color: "#1261d5",
      logo: "/aarchivos/bd617d84f1eadfd37f80932442c199f4.jpg",
      code: "654655",
      downloadUrl: "https://descargarflujotv.app/tv",
      mobileUrl: "https://descargarflujotv.app/cel",
      subtitle: "Instala IPTV Smarters Pro en tu televisor, TV Box, celular o tablet.",
      steps: [
        "Instala la aplicación Downloader desde la tienda de tu dispositivo.",
        "Abre Downloader, escribe el código y descarga el instalador.",
        "Instala la aplicación y solicita por WhatsApp tus datos de acceso.",
      ],
    },
    evo: {
      name: "Evo Pro Player",
      shortName: "EVO",
      path: "/instalar/evo-pro-player",
      color: "#7448e8",
      logo: "",
      code: "9381417",
      downloadUrl: "https://descargarflujotv.app/tv",
      mobileUrl: "",
      subtitle: "Configura Evo Pro Player en Smart TV, Android TV o TV Box.",
      steps: [
        "Descarga Downloader en tu Smart TV o TV Box.",
        "Ingresa el código de Evo Pro Player y selecciona descargar.",
        "Abre la aplicación y envíanos tu identificador para completar la activación.",
      ],
    },
    flujo: {
      name: "Flujo TV",
      shortName: "FTV",
      path: "/instalar/flujo-tv",
      color: "#0e9f80",
      logo: "/img/flujo.png",
      code: "9381417, 5586125 o 3261241",
      downloadUrl: "https://descargarflujotv.app/tv",
      mobileUrl: "https://descargarflujotv.app/cel",
      subtitle: "Descarga Flujo TV para Android, televisor o TV Box y empieza a ver en minutos.",
      steps: [
        "Selecciona el enlace correspondiente a tu dispositivo.",
        "Permite la instalación desde fuentes desconocidas e instala el archivo.",
        "Abre Flujo TV e ingresa las credenciales recibidas por WhatsApp.",
      ],
    },
    telelatino: {
      name: "Telelatino",
      shortName: "TL",
      path: "/instalar/telelatino",
      color: "#e34b67",
      logo: "",
      code: "CAMBIAR CÓDIGO",
      downloadUrl: "https://descargarflujotv.app/tv",
      mobileUrl: "https://descargarflujotv.app/cel",
      subtitle: "Plantilla editable para instalar Telelatino en TV, TV Box o dispositivo Android.",
      steps: [
        "Abre Downloader en tu dispositivo.",
        "Escribe el código configurado en el panel administrador.",
        "Instala la aplicación y solicita tus datos de acceso.",
      ],
    },
    "divedix-tv": {
      name: "Divedix TV",
      shortName: "DTV",
      path: "/instalar/divedix-tv",
      color: "#2a78e8",
      logo: "/branding/divedix-mark.png",
      code: "CAMBIAR CÓDIGO",
      downloadUrl: "https://descargarflujotv.app/tv",
      mobileUrl: "https://descargarflujotv.app/cel",
      subtitle: "Plantilla editable para la aplicación Divedix TV y sus sesiones de instalación.",
      steps: [
        "Instala Downloader desde la tienda de tu dispositivo.",
        "Introduce el código publicado desde el panel administrador.",
        "Abre Divedix TV e ingresa las credenciales recibidas.",
      ],
    },
  },
  comboDescuentos: [
    { minApps: 2, maxApps: 2, porcentaje: 5 },
    { minApps: 3, maxApps: 4, porcentaje: 10 },
    { minApps: 5, maxApps: 99, porcentaje: 20 },
  ],
  faqs: [
    {
      pregunta: "¿Cómo sé si un producto está disponible?",
      respuesta:
        "Cada ficha muestra las unidades o cupos registrados en el inventario. Antes del pago confirmamos la disponibilidad actual por WhatsApp.",
    },
    {
      pregunta: "¿Cómo recibo un equipo físico?",
      respuesta:
        "Cuando envías la solicitud coordinamos contigo la zona, el método de entrega o retiro y el costo correspondiente antes de recibir el pago.",
    },
    {
      pregunta: "¿Qué incluye un producto digital?",
      respuesta:
        "La ficha explica si se trata de una activación, instalación o configuración. También confirmamos duración, dispositivos y soporte antes de procesar la solicitud.",
    },
    {
      pregunta: "¿Qué métodos de pago puedo usar?",
      respuesta:
        "Puedes elegir entre los métodos habilitados por Divedix Store. Al seleccionar uno verás los datos configurados y la solicitud llegará a WhatsApp con tu elección.",
    },
  ],
  paises: [
    { code: "US", name: "Estados Unidos", currency: "USD", symbol: "$", rate: 1, flag: "🇺🇸" },
    { code: "DO", name: "República Dominicana", currency: "DOP", symbol: "RD$", rate: 59, flag: "🇩🇴" },
    { code: "CO", name: "Colombia", currency: "COP", symbol: "$", rate: 3900, flag: "🇨🇴" },
    { code: "MX", name: "México", currency: "MXN", symbol: "$", rate: 17, flag: "🇲🇽" },
    { code: "AR", name: "Argentina", currency: "ARS", symbol: "$", rate: 1000, flag: "🇦🇷" },
    { code: "CL", name: "Chile", currency: "CLP", symbol: "$", rate: 950, flag: "🇨🇱" },
    { code: "PE", name: "Perú", currency: "PEN", symbol: "S/", rate: 3.8, flag: "🇵🇪" },
    { code: "EC", name: "Ecuador", currency: "USD", symbol: "$", rate: 1, flag: "🇪🇨" },
    { code: "VE", name: "Venezuela", currency: "VES", symbol: "Bs", rate: 36, flag: "🇻🇪" },
    { code: "BO", name: "Bolivia", currency: "BOB", symbol: "Bs", rate: 6.9, flag: "🇧🇴" },
    { code: "PY", name: "Paraguay", currency: "PYG", symbol: "₲", rate: 7300, flag: "🇵🇾" },
    { code: "UY", name: "Uruguay", currency: "UYU", symbol: "$", rate: 39, flag: "🇺🇾" },
    { code: "BR", name: "Brasil", currency: "BRL", symbol: "R$", rate: 5.1, flag: "🇧🇷" },
    { code: "GT", name: "Guatemala", currency: "GTQ", symbol: "Q", rate: 7.8, flag: "🇬🇹" },
    { code: "HN", name: "Honduras", currency: "HNL", symbol: "L", rate: 24.7, flag: "🇭🇳" },
    { code: "SV", name: "El Salvador", currency: "USD", symbol: "$", rate: 1, flag: "🇸🇻" },
    { code: "NI", name: "Nicaragua", currency: "NIO", symbol: "C$", rate: 36.6, flag: "🇳🇮" },
    { code: "CR", name: "Costa Rica", currency: "CRC", symbol: "₡", rate: 510, flag: "🇨🇷" },
    { code: "PA", name: "Panamá", currency: "USD", symbol: "$", rate: 1, flag: "🇵🇦" },
    { code: "CU", name: "Cuba", currency: "CUP", symbol: "$", rate: 24, flag: "🇨🇺" },
    { code: "PR", name: "Puerto Rico", currency: "USD", symbol: "$", rate: 1, flag: "🇵🇷" },
    { code: "ES", name: "España", currency: "EUR", symbol: "€", rate: 0.92, flag: "🇪🇸" },
    { code: "CA", name: "Canadá", currency: "CAD", symbol: "C$", rate: 1.35, flag: "🇨🇦" },
    { code: "GB", name: "Reino Unido", currency: "GBP", symbol: "£", rate: 0.79, flag: "🇬🇧" },
  ],
};

const deepCopy = (value) => JSON.parse(JSON.stringify(value));

export function mergeCatalog(remote) {
  if (!remote || typeof remote !== "object") return deepCopy(DEFAULT_DATA);
  const base = deepCopy(DEFAULT_DATA);
  const remotePages = remote.downloadPages || {};
  const downloadPageKeys = new Set([...Object.keys(base.downloadPages), ...Object.keys(remotePages)]);
  const downloadPages = Object.fromEntries(
    [...downloadPageKeys].map((key) => {
      const page = { ...(base.downloadPages[key] || {}), ...(remotePages[key] || {}) };
      const fallbackPath = base.downloadPages[key]?.path || `/instalar/${key}`;
      page.path = typeof page.path === "string" && page.path.startsWith("/instalar/")
        ? page.path
        : fallbackPath;
      return [key, page];
    }),
  );
  if (!remote.downloadPages) {
    downloadPages.iptv.code = remote.iptvDownload?.smartersCode || downloadPages.iptv.code;
    downloadPages.iptv.downloadUrl = remote.iptvDownload?.tvUrl || downloadPages.iptv.downloadUrl;
    downloadPages.iptv.mobileUrl = remote.iptvDownload?.celularUrl || downloadPages.iptv.mobileUrl;
    downloadPages.evo.code = remote.iptvDownload?.evoCode || remote.iptvDownload?.iboCode || downloadPages.evo.code;
    downloadPages.evo.downloadUrl = remote.iptvDownload?.tvUrl || downloadPages.evo.downloadUrl;
    downloadPages.flujo.code = remote.flujoTVDownload?.tvCodes || downloadPages.flujo.code;
    downloadPages.flujo.downloadUrl = remote.flujoTVDownload?.tvUrl || downloadPages.flujo.downloadUrl;
    downloadPages.flujo.mobileUrl = remote.flujoTVDownload?.celularUrl || downloadPages.flujo.mobileUrl;
  }
  const hasLegacyFaqs = Array.isArray(remote.faqs) && remote.faqs.some((item) => [
    "¿Qué plan se adapta mejor a mí?",
    "¿Las cuentas son compartidas o privadas?",
    "¿Qué pasa si mi cuenta deja de funcionar?",
  ].includes(item?.pregunta));
  const remoteFaqs = Array.isArray(remote.faqs) && !hasLegacyFaqs ? remote.faqs : deepCopy(DEFAULT_DATA.faqs);
  const metodosPago = Number(remote.paymentRevision || 0) >= DEFAULT_DATA.paymentRevision
    && Array.isArray(remote.metodosPago) && remote.metodosPago.length
    ? remote.metodosPago
    : deepCopy(DEFAULT_DATA.metodosPago);
  const storeFolders = Number(remote.storeRevision || 0) >= DEFAULT_DATA.storeRevision
    && remote.storeFolders && typeof remote.storeFolders === "object"
    ? remote.storeFolders
    : deepCopy(DEFAULT_DATA.storeFolders);
  const storeProducts = Array.isArray(remote.storeProducts)
    ? remote.storeProducts.map((product) => {
      const folders = storeFolders[product.categoria] || [];
      return withNormalizedOffer({
        ...product,
        costo: Number(product.costo ?? product.precio ?? 0),
        moneda: product.moneda === "DOP" ? "DOP" : "USD",
        vendidos: Number(product.vendidos || 0),
        subcategoria: product.subcategoria || folders[0]?.id || "general",
      });
    })
    : deepCopy(DEFAULT_DATA.storeProducts).map(withNormalizedOffer);
  const perfumeProducts = Array.isArray(remote.perfumeProducts)
    ? remote.perfumeProducts.map((product) => withNormalizedOffer({
      ...product,
      categoria: "perfumes",
      costo: Number(product.costo ?? product.precio ?? 0),
      moneda: product.moneda === "DOP" ? "DOP" : "USD",
      vendidos: Number(product.vendidos || 0),
      stock: Math.max(0, Number(product.stock || 0)),
    }))
    : deepCopy(DEFAULT_DATA.perfumeProducts).map(withNormalizedOffer);
  const services = (Array.isArray(remote.services) ? remote.services : deepCopy(DEFAULT_DATA.services)).map((service) => ({
    ...service,
    planes: (Array.isArray(service.planes) ? service.planes : []).map((plan) => withNormalizedOffer({
      ...plan,
      moneda: plan.moneda === "DOP" ? "DOP" : "USD",
    })),
  }));
  const flujoTVPlanes = (Array.isArray(remote.flujoTVPlanes) ? remote.flujoTVPlanes : deepCopy(DEFAULT_DATA.flujoTVPlanes)).map((plan) => withNormalizedOffer({
    ...plan,
    moneda: plan.moneda === "DOP" ? "DOP" : "USD",
  }));
  const faqs = remoteFaqs.map((item) => item?.pregunta === "¿Qué tan rápido activan mi cuenta?"
    ? deepCopy(DEFAULT_DATA.faqs[0])
    : item);
  return {
    ...base,
    ...remote,
    paymentRevision: DEFAULT_DATA.paymentRevision,
    storeRevision: DEFAULT_DATA.storeRevision,
    services,
    storeProducts,
    perfumeProducts,
    perfumeConfig: { ...deepCopy(DEFAULT_DATA.perfumeConfig), ...(remote.perfumeConfig || {}) },
    gameRechargeConfig: (() => {
      const defaults = deepCopy(DEFAULT_DATA.gameRechargeConfig);
      const saved = remote.gameRechargeConfig || {};
      let result;
      if (Array.isArray(saved.juegos) && saved.juegos.length) result = { ...defaults, ...saved, juegos: saved.juegos };
      if (remote.freeFireConfig) {
        const legacyPackages = Array.isArray(remote.freeFireConfig.paquetes) ? remote.freeFireConfig.paquetes.map((item) => ({ ...item, cantidad: Number(item.cantidad ?? item.diamantes ?? 0) })) : [];
        defaults.activo = remote.freeFireConfig.activo !== false;
        defaults.juegos[0].paquetes = legacyPackages.length ? legacyPackages : defaults.juegos[0].paquetes;
      }
      result ||= { ...defaults, ...saved };
      return {
        ...result,
        juegos: (result.juegos || []).map((game) => ({
          ...game,
          paquetes: (game.paquetes || []).map(withNormalizedOffer),
        })),
      };
    })(),
    suggestionConfig: { ...deepCopy(DEFAULT_DATA.suggestionConfig), ...(remote.suggestionConfig || {}) },
    storeFolders,
    paises: Array.isArray(remote.paises) ? remote.paises : deepCopy(DEFAULT_DATA.paises),
    metodosPago,
    socialLinks: { ...deepCopy(DEFAULT_DATA.socialLinks), ...(remote.socialLinks || {}) },
    faqs,
    peliculasDestacadas: Array.isArray(remote.peliculasDestacadas) && remote.peliculasDestacadas.length
      ? remote.peliculasDestacadas
      : deepCopy(DEFAULT_DATA.peliculasDestacadas),
    flujoTVPlanes,
    comboDescuentos: Array.isArray(remote.comboDescuentos)
      ? remote.comboDescuentos
      : deepCopy(DEFAULT_DATA.comboDescuentos),
    flujoTVDownload: { ...deepCopy(DEFAULT_DATA.flujoTVDownload), ...(remote.flujoTVDownload || {}) },
    iptvDownload: { ...deepCopy(DEFAULT_DATA.iptvDownload), ...(remote.iptvDownload || {}) },
    downloadPages,
  };
}

export const resolveServiceImage = (service) => {
  if (service.imagen) return service.imagen;
  const fallback = DEFAULT_DATA.services.find((item) => item.id === service.id);
  return fallback?.imagen || "";
};
